import React from 'react';

class Logout extends React.Component {
  componentDidMount() {
    window.localStorage.removeItem('access_token');
    window.location.href = '/';
  }
  render() {
    return null;
  }
}

export default Logout;
